import { z } from 'zod';

const statusSchema = z
  .enum(['COMPLETE', 'IN_PROGRESS', 'NOT_STARTED'])
  .optional()
  .nullable();

export const classActivityFeedSchema = z.object({
  type: z.literal('resourceReport'),
  data: z.array(
    z.object({
      student: z.object({
        id: z.string(),
        lastName: z.string(),
        firstName: z.string(),
      }),

      columns: z
        .object({
          lastAccessed: z.string().nullable().optional(),
          minutesSpent: z.number().int().optional().nullable(),
          contentLexile: z.string().optional().nullable(),
          annotations: z.number().int().optional().nullable(),
          shortWrite: statusSchema.optional().nullable(),
          exitTicket: statusSchema.optional().nullable(),
          quizScore: z.number().optional().nullable(),
          mediaFile: statusSchema.optional().nullable(),
        })
        .optional(),
    })
  ),
});

export type ClassActivityFeed = z.infer<typeof classActivityFeedSchema>;
